import React, { forwardRef, useState } from 'react';
import { IconEye } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import drugsApiService from '../../../../services/drugsapi.service';
import DrugDrugMonographModal from './Monograph/DrugDrugMonographModal';
import COLOR_MAP from '../../../../constants/color-mapping';
import PopoverInfoIcon from '../../../../components/PopoverInfoIcon/PopoverInfoIcon';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';

const DrugDrugInteractions = forwardRef(function (
  { drugDrugInteractions },
  ref,
) {
  const [showModal, setShowModal] = useState(false);
  const [loadingMonographId, setLoadingMonographId] = useState(null);
  const [monoGraphData, setMonoGraphData] = useState(null);

  const handleFetchMonograph = async (monographId) => {
    setLoadingMonographId(monographId);
    try {
      const data = await drugsApiService.getDrugMonograph(monographId);
      setMonoGraphData(data);
      setShowModal(true);
    } catch (error) {
      console.error('Error fetching monograph:', error);
    } finally {
      setLoadingMonographId(null);
    }
  };
  return (
    <div
      ref={ref}
      className="mb-36 scroll-offset"
      id="drug-drug-interactions-section"
    >
      <h4>Drug-Drug Interactions</h4>
      {drugDrugInteractions?.Interactions?.length ? (
        <div className="ps-table table-responsive mb-4 mt-3">
          <table className="table responsive-drug-table w-100">
            <thead>
              <tr>
                <th scope="col">DRUG NAME</th>
                <th scope="col">CLINICAL EFFECT</th>
                <th scope="col">
                  SEVERITY DESCRIPTION
                  <PopoverInfoIcon
                    popoverInfo={COLOR_MAP.DrugDrugInteractions}
                  />
                </th>
                <th scope="col">Monograph</th>
              </tr>
            </thead>
            <tbody>
              {drugDrugInteractions.Interactions.sort(
                (a, b) => Number(a.Severity) - Number(b.Severity),
              ).map((interaction, index) => (
                <tr key={`interaction-${index}`}>
                  <td data-label="DRUG NAME">{interaction.InteractionDesc}</td>
                  <td data-label="CLINICAL EFFECT">
                    {interaction.ClinicalEffect1Desc}
                  </td>
                  <td data-label="SEVERITY DESCRIPTION">
                    <span
                      className={
                        COLOR_MAP.DrugDrugInteractions[interaction.SeverityDesc]
                      }
                    />
                    {interaction.SeverityDesc}
                  </td>
                  <td data-label="Monograph">
                    <button
                      type="button"
                      className="btn view-btn gap-1"
                      onClick={() =>
                        handleFetchMonograph(interaction.MonographID)
                      }
                      disabled={
                        loadingMonographId &&
                        loadingMonographId !== interaction.MonographID
                      }
                    >
                      <IconEye size={18} className="ti ti-eye" />
                      {loadingMonographId === interaction.MonographID ? (
                        <span className="spinner-border spinner-border-sm" />
                      ) : (
                        'View'
                      )}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <InfoUnavailable />
      )}
      <DrugDrugMonographModal
        show={showModal}
        onHide={() => setShowModal(false)}
        monoGraphData={monoGraphData}
        loading={Boolean(loadingMonographId)}
      />
    </div>
  );
});

DrugDrugInteractions.propTypes = {
  drugDrugInteractions: PropTypes.object.isRequired,
};

DrugDrugInteractions.displayName = 'DrugDrugInteractions';

export default DrugDrugInteractions;
